import {ActionReducerMapBuilder, createSlice, type SliceSelectors, type SliceCaseReducers} from '@reduxjs/toolkit'

import {
    changePhoneNumber,
    toggleReceiverModified,
    toggleVirtualPhoneNumberUsing,
    PickupState,
    getInitialState,
} from '@web/slices/pickup/slice'

interface Options {
    extraReducers?: (builder: ActionReducerMapBuilder<PickupState>) => void
}

const makeSlice = (options: Options) =>
    createSlice<PickupState, SliceCaseReducers<PickupState>, 'pickup', SliceSelectors<PickupState>>({
        name: 'pickup',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(toggleVirtualPhoneNumberUsing, (state) => {
                    state.receiver && (state.receiver.useVirtualNumber = !state.receiver.useVirtualNumber)
                })
                .addCase(toggleReceiverModified, (state) => {
                    state.receiver && (state.receiver.modified = !state.receiver.modified)
                })
                .addCase(changePhoneNumber, (state, {payload}) => {
                    state.receiver && (state.receiver.phoneNumber = payload)
                })
            options?.extraReducers?.(builder)
        },
    })

export default makeSlice
